export enum SearchTypes {
  Atlas = 'atlas',
  Folder = 'folder',
  Journey = 'journey',
  Persona = 'persona',
}
